import { React, useEffect } from "react";
import CustomInput from "../components/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";
import { useFormik } from "formik";
import { BiArrowBack } from "react-icons/bi";
import {
  createBrand,
  getABrand,
  resetState,
  updateABrand,
} from "../features/sectors/sectorSlice";

let schema = yup.object().shape({
  title: yup.string().required("Sector Name is Required"),
});
const Addsectors = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const getBrandId = location.pathname.split("/")[3];
  const newBrand = useSelector((state) => state.sectors);
  const {
    isSuccess,
    isError,
    isLoading,
    createdSector,
    sectorName,
    updatedSector,
  } = newBrand;
  useEffect(() => {
    if (getBrandId !== undefined) {
      dispatch(getABrand(getBrandId));
    } else {
      dispatch(resetState());
    }
  }, [getBrandId]);

  const goBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (isSuccess && createdSector) {
      toast.success("Sector Added Successfullly!");
      navigate("/admin/list-sectors");
    }
    if (isSuccess && updatedSector) {
      toast.success("Sector Updated Successfullly!");
      navigate("/admin/list-sectors");
    }

    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: sectorName || "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (getBrandId !== undefined) {
        const data = { id: getBrandId, brandData: values };
        dispatch(updateABrand(data));
        dispatch(resetState());
      } else {
        dispatch(createBrand(values));
        formik.resetForm();
        // setTimeout(() => {
        //   dispatch(resetState());
        // }, 300);

      }
    },
  });

  return (
    <div>
      <h3 className="mb-4 title">
        {getBrandId !== undefined ? "Edit" : "Add"} Sector
      </h3>
      <button
          className="bg-transpatent border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5" /> Go Back
       </button>
      <div>
        <form action="" onSubmit={formik.handleSubmit}>
          <CustomInput
            type="text"
            name="title"
            onChng={formik.handleChange("title")}
            onBlr={formik.handleBlur("title")}
            val={formik.values.title}
            label="Enter Sector Name"
            id="brand"
          />
          <div className="error">
            {formik.touched.title && formik.errors.title}
          </div>
          <button
            className="btn btn-success border-0 rounded-3 my-5"
            type="submit"
          >
            {getBrandId !== undefined ? "Edit" : "Add"} Sector
          </button>
        </form>
      </div>
    </div>
  );
};

export default Addsectors;